export default "__VITE_ASSET__beed0a19__"